export function mapErrorStates (fields) {
  let getters = {}
  for (let field of fields) {
    let stateGetter = ('state_' + field).replace(/(_[a-z])/g, (m, p) => p[1].toUpperCase())
    let errorGetter = ('error_' + field).replace(/(_[a-z])/g, (m, p) => p[1].toUpperCase())
    getters[stateGetter] = function () {
      return this.errors[field] ? false : null
    }
    getters[errorGetter] = function () {
      return this.errors[field]
    }
  }
  return getters
}



// WEBPACK FOOTER //
// ./src/helpers/errors.js